import { ALERT_TITLE, ALERT_TYPE } from '../constants/alertsConstant';
import { PAGE } from '../constants/commonConstants';
import { getForecastSubmittedStatus, getUserRole } from '../services/commonServices';
import {
  dateFormatWithoutYear,
  formatDateToYYYYMMDD,
  getRemainingDays,
  getTime12Hr,
} from './commonUtil';

export const QuaterlyDetailsChangeKeys = OppArray => {
  return OppArray.map(item => {
    return {
      commit: item.commit_status,
      opportunity_id: item.opportunity_id,
      tov: item.tov,
      awd: formatDateToYYYYMMDD(item.awd),
      month: item.month,
      period: item.awd_period,
      fiscal_year: item.fiscal_year,
      status: item.statuscode,
      stage: item.stagecode,
      assurance: item.ASU, //ASU
      consulting: item.CNS, //CNS
      sat: item.SAT,
      tax: item.TAX,
      pas: item.PAS,
      itts: item.ITTS,
      emia_acr: item.EMIA_ACR, //EMIA_ACR
      account: item?.account,
      month: item.fiscal_month,
      period: item.fiscal_quarter,
      close_probability: item.close_probablity,
      ey_id: item.ey_id ? item.ey_id : '0000',
      opportunity_name: item?.opportunity_name,
      client_id: item.client,
      client_name: item.client_name,
      stage_name: item.stagecode_name,
      account_name: item?.account_name,
    };
  });
};

export const filterOpportunityById = (array1, array2) => {
  const filteredArray = array2.filter(item2 =>
    array1.some(item1 => item1.opp_id == item2.opportunity_id),
  );
  return filteredArray;
};

export const GcspPostChangeKeys = (OppArray, SubmissionType, isRollingData, MONTH) => {
  // Static month written for condition to send year + 1
  // if month is july or aug sending year + 1;
  const CurrentMonth = ['may', 'jun'];
  const PostMonth = ['jul', 'aug'];
  return OppArray.map(item => {
    const data = {
      assurance: Number(item.Assurance), //ASU
      consulting: Number(item.consulting), //CNS
      sat: Number(item.sat),
      tax: Number(item.tax),
      pas: Number(item.pas),
      itts: Number(item.itts),
      emia_acr: Number(item.EMIAACR),
      submission_type: SubmissionType,
    };

    if (isRollingData) {
      if (
        CurrentMonth.includes(MONTH.toLowerCase()) &&
        PostMonth.includes(item.month.toLowerCase())
      ) {
        data.month = item.month;
        data.quarter = item.quarter;
        data.year = item.year + 1;
      } else {
        data.month = item.month;
        data.quarter = item.quarter;
        data.year = item.year;
      }
    }
    return data;
  });
};

export const getCurrentUser = data => {
  let user = {
    email: localStorage.getItem('userEmail'),
    role: data?.role,
    account_id: data?.accountList[0]?.account_id,
  };

  return user;
};

export const getOldCurrentUser = data => {
  let user = {
    email: localStorage.getItem('userEmail'),
    role: data?.role,
    account_id: data?.account_id,
  };

  return user;
};

export const gcspPostJudgeData = async (
  ACCOUNTID,
  EMAIL,
  MONTH,
  YEAR,
  QUARTER,
  gcspOppViewData,
  activeTab,
) => {
  let REQ_BODY;

  if (Object.keys(gcspOppViewData.Your_Judge).length !== 0) {
    REQ_BODY = GcspPostChangeKeys(gcspOppViewData.Your_Judge, activeTab);
  }
  REQ_BODY = JSON.stringify(REQ_BODY[0]);
  try {
    const response = await postGCSPJudgeData(ACCOUNTID, EMAIL, MONTH, YEAR, QUARTER, REQ_BODY);
    return response;
  } catch (error) {
    console.log('Error', error);
  }
};

export const filterParams = {
  comparator: (filterLocalDateAtMidnight, cellValue) => {
    var dateAsString = cellValue;
    if (dateAsString == null) return -1;
    var dateParts = dateAsString.split('/');
    var cellDate = new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0]));
    if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
      return 0;
    }
    return cellDate < filterLocalDateAtMidnight ? -1 : cellDate > filterLocalDateAtMidnight ? 1 : 0;
  },
};

export const DateFiltering = {
  // For YYYY-MM-DD Date Formate
  comparator: (filterLocalDateAtMidnight, cellValue) => {
    var dateAsString = cellValue;
    if (dateAsString == null) return -1;
    var dateParts = dateAsString.split('-');
    var cellDate = new Date(Number(dateParts[0]), Number(dateParts[1]) - 1, Number(dateParts[2]));
    if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
      return 0;
    }
    return cellDate < filterLocalDateAtMidnight ? -1 : cellDate > filterLocalDateAtMidnight ? 1 : 0;
  },
};

export const DateSorting = (date1, date2) => {
  // For YYYY-MM-DD Date Formate
  const monthToComparableNumber = date => {
    if (date === undefined || date === null) {
      return null;
    }
    const parts = date.split('-');
    var dayNumber = Number.parseInt(parts[2]);
    var monthNumber = Number.parseInt(parts[1]);
    var yearNumber = Number.parseInt(parts[0]);

    return yearNumber * 10000 + monthNumber * 100 + dayNumber;
  };

  const date1Number = monthToComparableNumber(date1);
  const date2Number = monthToComparableNumber(date2);
  if (date1Number === null && date2Number === null) {
    return 0;
  }
  if (date1Number === null) {
    return -1;
  }
  if (date2Number === null) {
    return 1;
  }
  return date1Number - date2Number;
};

export const OppsNameSorting = (name1, name2) => {
  if (name1 === undefined || name2 === undefined) {
    return;
  }

  return name1.localeCompare(name2);
};

export const clientAccountNameSorting = (valueA, valueB) => {
  if (valueA === undefined || valueB === undefined) {
    return;
  }

  const isSpecialChar = char => /[^a-zA-Z0-9]/.test(char);
  const isNumericChar = char => /[0-9]/.test(char);
  const isAlphabeticChar = char => /[a-zA-Z]/.test(char);

  const getOrder = char => {
    if (isSpecialChar(char)) return 1;
    if (isNumericChar(char)) return 2;
    if (isAlphabeticChar(char)) return 3;
    return 4;
  };
  const trimmedA = valueA.trim();
  const trimmedB = valueB.trim();
  const orderA = getOrder(trimmedA.charAt(0));
  const orderB = getOrder(trimmedB.charAt(0));
  if (orderA !== orderB) {
    return orderA - orderB;
  }

  return trimmedA.localeCompare(trimmedB);
};

export const QuarterYearSorting = (a, b) => {
  const yearA = a.slice(-4);
  const yearB = b.slice(-4);
  const quarterA = a.slice(0, 2);
  const quarterB = b.slice(0, 2);

  // Compare years first
  if (yearA !== yearB) {
    return yearA - yearB;
  }

  // If years are equal, compare quarters
  const quarters = ['Q1', 'Q2', 'Q3', 'Q4'];
  return quarters.indexOf(quarterA) - quarters.indexOf(quarterB);
};

// Revised Code
export const getAlertBarDetails = async (quarterData, apiPayload, screenName, systemDateTime) => {
  let alertDetails;

  let forcastOpensInDays = getRemainingDays(quarterData.persona_startdate, systemDateTime);
  let forcastDueInDays = getRemainingDays(quarterData.persona_closedate, systemDateTime);

  let personaStartDate = dateFormatWithoutYear(quarterData.persona_startdate);
  let personaCloseDate = dateFormatWithoutYear(quarterData.persona_closedate);
  let personaNextStartDate = dateFormatWithoutYear(quarterData.persona_nextstartdate);

  let startDateTime = getTime12Hr(new Date(quarterData.persona_startdate));
  let closeDateTime = getTime12Hr(new Date(quarterData.persona_closedate));
  let nextStartDateTime = getTime12Hr(new Date(quarterData.persona_nextstartdate));

  if (forcastOpensInDays > 5) {
    alertDetails = {
      description: `Next Forecast opens on ${personaStartDate}, ${startDateTime}`,
      title: ALERT_TITLE.FORECAST_OPENS_SOON,
      type: ALERT_TYPE.WARNING,
      showButton: false,
      userDropdownChip: `Opens on ${personaStartDate}`,
    };
  } else {
    if (forcastOpensInDays <= 5 && forcastOpensInDays >= 2) {
      // forcastOpensInDays between 5 to 2
      alertDetails = {
        description: `Forecast opens in ${forcastOpensInDays} days, ${personaStartDate}, ${startDateTime}`,
        title: ALERT_TITLE.FORECAST_OPENS_SOON,
        type: ALERT_TYPE.WARNING,
        showButton: false,
        userDropdownChip: `Opens in ${forcastOpensInDays} days`,
      };
    } else if (forcastOpensInDays == 1) {
      alertDetails = {
        description: `Forecast opens tomorrow, ${personaStartDate}, ${startDateTime}`,
        title: ALERT_TITLE.FORECAST_OPENS_TOMORROW,
        type: ALERT_TYPE.WARNING,
        showButton: false,
        userDropdownChip: `Opens Tomorrow`,
      };
    } else if (forcastOpensInDays <= 0) {
      const status = await getForecastSubmittedStatus(apiPayload);
      if (status.monthly_submission === 'Submitted') {
        alertDetails = {
          description: `Forecast has been submitted and can be edited until ${personaCloseDate}, ${closeDateTime}`,
          title: ALERT_TITLE.FORECAST_SUBMITTED,
          type: ALERT_TYPE.SUCCESS,
          showButton: true,
          userDropdownChip: `Submitted`,
        };
      } else {
        if (forcastDueInDays > 5 && forcastOpensInDays < 0) {
          alertDetails = {
            description: `Forecast due on ${personaCloseDate}, ${closeDateTime}`,
            title: ALERT_TITLE.FORECAST_DUE,
            type: ALERT_TYPE.WARNING,
            showButton: false,
            userDropdownChip: `Due on ${personaCloseDate}`,
          };
        } else {
          if (forcastDueInDays <= 5 && forcastDueInDays >= 2) {
            // forcastDueInDays between 5 to 2
            alertDetails = {
              description: `Forecast due in ${forcastDueInDays} days, on ${personaCloseDate}, ${closeDateTime}`,
              title: ALERT_TITLE.FORECAST_DUE_SOON,
              type: ALERT_TYPE.NEEDS_ACTION,
              showButton: false,
              userDropdownChip: `Due in ${forcastDueInDays} days`,
            };
          } else if (forcastDueInDays == 1) {
            if (apiPayload.role == 'PL') {
              alertDetails = {
                description: `Forecast due tomorrow, ${personaCloseDate}, ${closeDateTime}`,
                title: ALERT_TITLE.FORECAST_DUE_TOMORROW,
                type: ALERT_TYPE.NEEDS_ACTION,
                showButton: true,
                userDropdownChip: `Due Tomorrow`,
              };
            } else if (apiPayload.role == 'GCSP') {
              alertDetails = {
                description: `Forecast opens today, ${personaStartDate}, ${startDateTime}`,
                title: ALERT_TITLE.FORECAST_OPENS_TODAY,
                type: ALERT_TYPE.WARNING,
                showButton: false,
                userDropdownChip: `Opens Today`,
              };
            }
          } else if (forcastDueInDays == 0) {
            if (new Date(systemDateTime) < new Date(quarterData.persona_closedate)) {
              alertDetails = {
                description: `Forecast due today, ${personaCloseDate}, ${closeDateTime}`,
                title: ALERT_TITLE.FORECAST_DUE_TODAY,
                type: ALERT_TYPE.NEEDS_ACTION,
                showButton: true,
                userDropdownChip: `Due Today`,
              };
            } else {
              alertDetails = {
                description: `Next Forecast opens on ${personaNextStartDate}, ${nextStartDateTime}`,
                title: ALERT_TITLE.FORECAST_OPENS_SOON,
                type: ALERT_TYPE.WARNING,
                showButton: false,
                userDropdownChip: `Opens on ${personaNextStartDate}`,
              };
            }
          } else if (forcastOpensInDays == 0) {
            alertDetails = {
              description: `Forecast opens today, ${personaStartDate}, ${startDateTime}`,
              title: ALERT_TITLE.FORECAST_OPENS_TODAY,
              type: ALERT_TYPE.WARNING,
              showButton: false,
              userDropdownChip: `Opens Today`,
            };
          }
        }
      }
    }
  }
  if (alertDetails == undefined || alertDetails == null) {
    console.log('No Alert Found :(');
  } else {
    // If page is Forecast then removing Start Foecast button from alert
    screenName == PAGE.FORECAST ? (alertDetails.showButton = false) : null;
    return alertDetails;
  }
};

export const delay = ms =>
  new Promise(resolve => {
    return setTimeout(resolve, ms);
  });

export const retainCommitAndModifyOpportunity = (oldOpportunityData, newOpportunityData) => {
  return newOpportunityData.map(newItem => {
    let matchingItem = oldOpportunityData.find(
      oldItem => oldItem.opportunity_id === newItem.opportunity_id,
    );
    if (!!matchingItem) {
      newItem.commit_status = matchingItem.commit_status;

      return {
        ...newItem,
      };
    } else {
      return newItem;
    }
  });
};

export const isCurrentUserExist = async () => {
  const previouslySelectedUser = JSON.parse(localStorage.getItem('selectedUser'));
  const accountIdToFind = previouslySelectedUser?.account_id;
  const userRoleList = await getUserRole(localStorage.getItem('userEmail'));
  let isAccountIdFound = false;

  userRoleList.forEach(role => {
    role.accountList.forEach(account => {
      if (account.account_id === accountIdToFind) {
        isAccountIdFound = true;
      }
    });
  });

  return isAccountIdFound;
};
